import React from "react";
import { ArrowUpRight, BookOpen } from "lucide-react";
import { DiamondBorder, SectionLabel } from "./AipanPattern";
import { useNavigate } from "react-router-dom";
import { IMAGES } from "../mock";

export default function About() {
 const navigate = useNavigate();
  return (
    // <section id="about" className="relative py-14 bg-[var(--paper)] paper-grain -mt-[50px]">
    <section
  id="about"
  className="relative pt-8 pb-12 bg-[var(--paper)] paper-grain"
>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 relative">
            <div className="relative rounded-[28px] overflow-hidden aspect-[4/3] shadow-2xl border-[6px] border-white">
              <img src={IMAGES.kumauncover1} alt="Himalayan Vista" className="h-full w-full object-cover" />
            </div>
            <div className="absolute -bottom-8 -right-4 md:-right-8 w-44 h-44 rounded-[24px] overflow-hidden border-[6px] border-white shadow-xl">
              <img src={IMAGES.kumauncover2} alt="Pine Forest" className="h-full w-full object-cover" />
            </div>
            <div className="absolute -top-6 -left-4 bg-[var(--saffron)] text-white rounded-2xl px-4 py-3 shadow-lg">
              <div className="font-display text-[28px] leading-none">52</div>
              <div className="text-[10px] tracking-[0.18em] uppercase">Years Strong</div>
            </div>
          </div>

          <div className="lg:col-span-7 text-lg font-gill self-start">
            <SectionLabel>About the University</SectionLabel>
            {/* <h2 className="mt-5 font-display text-[38px] lg:text-[48px] leading-[1.08] font-bold text-[var(--ink)]">
              A residential-cum-affiliating <span className="italic text-[var(--terracotta)]">university</span> in the heart of the Kumaon Himalayas.
            </h2> */}
            <DiamondBorder className="my-8 max-w-md" />
            <p className="text-[16px] leading-relaxed text-[var(--ink)]/75 text-justify">
              Kumaun University, a residential-cum-affliating university, came into existence in the year 1973 by notification No. (10)/8651/15/75(85)/64 dated 23 November, 1973 under the Act No. 10 of State Legislature (U.P. State Universities Act, 1973 now adopted by Uttarakhand State) with the merger of two Government Colleges, D.S.B. Government P.G.College, Nainital and Almora Government P.G. College, Almora. These Constituent Colleges were later elevated to the status of University Campuses by Government order No. E-1861/GS dated 14/15 March, 1994.
            </p>
            {/* <p className="mt-4 text-[16px] leading-relaxed text-[var(--ink)]/75">
              Established in 1973, Kumaun University, nestled in Uttarakhand, emerged from the merger of two eminent government colleges, namely, D.S.B. Government P.G. College, Nainital and Almora Government P.G. College. Kumaun University earned its recognition from the University Grants Commission (UGC) in New Delhi under Section 12-B of the UGC Act, 1956. This recognition enabled the University to receive consistent support from the UGC. Over time, the University transformed from a mere institution to a leading academic beacon for thousands in the Kumaun Region of Uttarakhand.
            </p> */}

               {/* <div className="mt-8 grid sm:grid-cols-2 gap-4">
                    {[
                      { title: "Two constituent campuses", body: (
                        
                  <>
                    D.S.B. Campus Nainital,
                    <br/>
                    Sir J.C. Bose Technical Campus Bhimtal
                  </>
                ),
              
              },
                { title: "72 affiliated colleges", body: "An academic network that reaches Nainital & Udham Singh Nagar district of Uttarakhand." },
              ].map((c) => (
                <div key={c.title} className="rounded-2xl bg-white p-5 border border-[var(--cream-deep)] card-lift">
                  <div className="flex items-start gap-3">
                    <div className="h-9 w-9 rounded-lg bg-[var(--terracotta)]/10 text-[var(--terracotta)] grid place-items-center">
                      <BookOpen size={17} />
                    </div>
                    <div>
                      <div className="font-display font-bold text-[17px] text-[var(--ink)]">{c.title}</div>
                      <div className="text-[13.5px] text-[var(--ink)]/65 mt-1">{c.body}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div> */}
            <div className="mt-8 grid sm:grid-cols-2 gap-4">
  {[
    {
      title: "Two constituent campuses",
      body: (
        <>
          D.S.B. Campus Nainital,
          <br />
          Sir J.C. Bose Technical Campus Bhimtal
        </>
      ),
      link: "/about/campus",
    },
    {
      title: "72 affiliated colleges",
      body: "An academic network that reaches Nainital & Udham Singh Nagar district of Uttarakhand.",
      link: "/about/colleges-list",
    },
  ].map((c) => (
    <div
      key={c.title}
      className="rounded-2xl bg-white p-5 border border-[var(--cream-deep)] card-lift"
    >
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-lg bg-[var(--terracotta)]/10 text-[var(--terracotta)] grid place-items-center">
          <BookOpen size={17} />
        </div>

        <div>
          <div
            onClick={() => navigate(c.link)}
            className="font-display font-bold text-[17px] text-[var(--ink)] cursor-pointer hover:text-blue-600 hover:underline"
          >
            {c.title}
          </div>

          <div className="text-[13.5px] text-[var(--ink)]/65 mt-1">
            {c.body}
          </div>
        </div>
      </div>
    </div>
  ))}
</div>

            <a href="/about/university-at-a-glance" className="mt-8 inline-flex items-center gap-2 text-[var(--terracotta)] font-semibold link-sweep">
              Read the full story <ArrowUpRight size={17} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
